// extracted by mini-css-extract-plugin
export default {"title":"OnlineTransactions_title__YQuk8","post":"OnlineTransactions_post__QDuke","button":"OnlineTransactions_button__J8XVS"};